import type { NskResponse } from "~/models/Api";
import type { DealInspectionCandidateDateParam } from "~/models/InspectionCandidateDate";
import { putRequest } from "~/utils/api/api_handler";

const paths = {
	update: "/deals/:deal_id/deal_inspection_candidate_dates"
};

export const update = async (
	dealId: number,
	dealInspectionCandidateDates: DealInspectionCandidateDateParam
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":deal_id", String(dealId)), {
		dealInspectionCandidateDates
	});
